import { LANGUAGE_DEFAULT_LOCALE_MAP, LOCALE_CASE_INSENSITIVE_MAP } from '../const';

export function getValidLocale(locale: string | null | undefined): string | undefined {
  if (!locale) return undefined;

  // Try to find an exact match
  /**
   * map keys are converted to lowercase before storing in the map
   * hence we need to convert the locale to lowercase before checking whether it matches
   */
  const exactMatch = LOCALE_CASE_INSENSITIVE_MAP.get(locale.toLowerCase());
  if (exactMatch) return exactMatch;

  // Try to find a match with the language
  const match = LANGUAGE_DEFAULT_LOCALE_MAP.get(locale.split('-')[0]);
  if (match) return match;

  return undefined;
}
